module.exports = __webpack_public_path__ + "img/logo_row_white_en.63a13612.svg";